import { c as _c } from "react/compiler-runtime";
import { Dialog } from '@base-ui/react/dialog';
import { css } from '@repo/pandacss/css';
import { usePageAction } from '@repo/platform-analytics/hooks/usePageAction';
import { Button } from '@repo/ui/Button';
import { Link } from '@repo/ui/Link';
import type { BranchId } from '@/shared/config/funnel/constants';
import { ANALYTICS_ACTION_NAME, ANALYTICS_EXIT_INTENT_ACTION_SECTION } from './constants';
type CTAsProps = {
  parentActivityId: string;
  branchId: BranchId | null;
};
export function CTAs(t0) {
  const $ = _c(21);
  const {
    parentActivityId,
    branchId
  } = t0;
  let t1;
  if ($[0] !== branchId || $[1] !== parentActivityId) {
    t1 = {
      actionName: ANALYTICS_ACTION_NAME,
      actionSection: ANALYTICS_EXIT_INTENT_ACTION_SECTION,
      actionType: "select",
      actionInput: "exit",
      parentActivityId,
      pageBranchName: branchId
    };
    $[0] = branchId;
    $[1] = parentActivityId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const fireExitPageActionAnalyticsEvent = usePageAction(t1);
  let t2;
  if ($[3] !== branchId || $[4] !== parentActivityId) {
    t2 = {
      actionName: ANALYTICS_ACTION_NAME,
      actionSection: ANALYTICS_EXIT_INTENT_ACTION_SECTION,
      actionType: "select",
      actionInput: "return",
      parentActivityId,
      pageBranchName: branchId
    };
    $[3] = branchId;
    $[4] = parentActivityId;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const fireReturnPageActionAnalyticsEvent = usePageAction(t2);
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = css({
      display: "flex",
      flexDirection: "column",
      gap: "3"
    });
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== fireReturnPageActionAnalyticsEvent) {
    t4 = () => fireReturnPageActionAnalyticsEvent();
    $[7] = fireReturnPageActionAnalyticsEvent;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = css({
      height: "[45px]",
      fontSize: "14px"
    });
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4) {
    t6 = <Dialog.Close render={<Button onClick={t4} className={t5}>KEEP GOING</Button>} />;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== fireExitPageActionAnalyticsEvent) {
    t7 = () => fireExitPageActionAnalyticsEvent();
    $[12] = fireExitPageActionAnalyticsEvent;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = css({
      width: "[100%]",
      bg: "common.white",
      border: "[1px solid]",
      borderColor: "greens.main",
      height: "[45px]",
      fontSize: "14px",
      fontWeight: "semibold",
      cursor: "pointer",
      textStyle: "body",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      py: "3",
      px: "3.5",
      _hover: {
        bg: "neutral.lightest"
      }
    });
    t9 = {
      color: "greens.main"
    };
    $[14] = t8;
    $[15] = t9;
  } else {
    t8 = $[14];
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t7) {
    t10 = <Link onClick={t7} href="https://www.nerdwallet.com/credit-cards/best" underline="none" className={t8} css={t9}>NO, THANKS</Link>;
    $[16] = t7;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t6) {
    t11 = <div className={t3}>{t6}{t10}</div>;
    $[18] = t10;
    $[19] = t6;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
}